export default __webpack_public_path__ + "static/media/google-play-icon.a618ac3a.svg";